import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { CONSTANTS } from '../../../constants/constants';
import OnDiskFalseIcon from '../../../NRIcons/OnDiskFalseIcon';
import OnDiskTrueIcon from '../../../NRIcons/OnDiskTrueIcon';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/system/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

const { ROWS } = CONSTANTS.TABLE.SBOM_TABLE;

const getBooleanColumnTitle = columnName => {
  // if (columnName === 'isPredicted') return ROWS.PREDICTED;
  return ROWS.ONDISK;
};

const BooleanCheckFormatter = ({ value, column }) => {
  const theme = useTheme();
  const title = getBooleanColumnTitle(column?.name);

  const TooltipContent = () => (
    <Box display="flex" flexDirection="column" p={0.5}>
      <Typography variant="caption" fontWeight={theme.typography.fontWeightBold}>
        {title}
      </Typography>
      <Typography variant="caption">{value ? 'True' : 'False'}</Typography>
    </Box>
  );

  return (
    <Tooltip placement="top" title={<TooltipContent />}>
      <Box display="flex" alignItems="center" justifyContent="center">
        {value ? (
          <OnDiskTrueIcon color={theme.palette.info.main} width={20} height={20} />
        ) : (
          <OnDiskFalseIcon color={theme.palette.text.disabled} width={20} height={20} />
        )}
      </Box>
    </Tooltip>
  );
};
export const BooleanCheckProvider = props => <DataTypeProvider formatterComponent={BooleanCheckFormatter} {...props} />;
